import React , {useState} from 'react';
import { InputText } from 'primereact/inputtext';
import {useAuth} from './context/AuthContext';

export const AppTopbar = (props) => {

    const {logout} = useAuth();
    const [mierror, setMierror] = useState('');

    const handleLogout = async () =>{
        try {
            // alert('ingreso');
            await logout();
        } catch (error) {
            setMierror('Error del Servidor');
            //console.log (error);
            alert(mierror);
        }

    };



    return (
        <div className="layout-topbar clearfix">
            <button type="button" className="p-link layout-menu-button" onClick={props.onToggleMenu}>
                <span className="pi pi-bars" />
            </button>
            <div className="layout-topbar-icons">
                {/* <span className="layout-topbar-search">
                    <InputText type="text" placeholder="Search" />
                    <span className="layout-topbar-search-icon pi pi-search" />
                </span> */}


                <button type="button" className="p-link" onClick={handleLogout}>
                    <span className="layout-topbar-item-text">Salir</span>
                    <span className="layout-topbar-icon pi pi-fw pi-power-off" />
                </button>
            </div>
        </div>
    );
}


